import { React, useContext } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ThemeContext from '../../context/ThemeContext';

import {
  faLinkedin,
  faGoogle,
  faInstagram,
} from "@fortawesome/free-brands-svg-icons";

import "./Footer.css";

const Footer = () => {
  const { theme } = useContext(ThemeContext);

  return (
    <footer className={`footer ${theme}`}>
      <div className="footer-container">
        {/* سمت چپ: کپی‌رایت و نام سازنده */}
        <div className="footer-left">
          <p className={`copyright ${theme}`}>
            &copy; <span id="date">{new Date().getFullYear()}</span> <span className="vahid">Vahid Hanid</span> . All rights reserved .
            Website created by{" "}
            <a
              href="https://github.com/aminpirakand"
              target="_blank"
              rel="noopener noreferrer"
              className={`creator-link ${theme}`}
            >
              Amin Pirakand
            </a>
          </p>
        </div>

        {/* سمت راست: شبکه‌های اجتماعی */}
        <nav className="social-media">
          <ul>
            <li>
              <a
                href="https://www.linkedin.com/in/vahidhanid"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FontAwesomeIcon
                  icon={faLinkedin}
                  className={`social-icon ${theme}`}
                  title="linkedin"
                />
              </a>
            </li>
            <li>
              <a
                href="https://mail.google.com/mail/?view=cm&fs=1&to=vahidhanid96@gmail.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FontAwesomeIcon
                  icon={faGoogle}
                  className={`social-icon ${theme}`}
                  title="gmail"
                />
              </a>
            </li>
            <li>
              <a
                href="https://www.instagram.com/vahidhanid0014?igsh=Ym5qeXo1Mnd0NXFj"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FontAwesomeIcon
                  icon={faInstagram}
                  className={`social-icon ${theme}`}
                  title="instagram"
                />
              </a>
            </li>
          </ul>
        </nav>
      </div>
    </footer>
  );
};

export default Footer;